import {ApiServiceService} from '../api-service.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {LenderDashboardLinkProvider} from '../utils/lenderDashboardLinkProvider';
import {PreferencesService} from '../service/preferences.service';
import {Preferences} from '../model/preferences.model';
import {ConfigService} from '../service/config.service';
import {MatDialog} from '@angular/material';
import {VirtualAccountDescriptionPopUpComponent} from '../views/virtual-account-description-pop-up/virtual-account-description-pop-up.component';
import {HttpClient} from '@angular/common/http';
import { Router } from '@angular/router';
import {PaymentProduct} from '../model/payment/PaymentCollectionRequest';
import { AttributeCode, AttributeValue, UserAttributeInterface } from '../model/finzy-flex/user-attribute.model';
import { ConfirmationPopupWithSvgComponent } from '../views/investors/finzy-flex/confirmation-popup-with-svg/confirmation-popup-with-svg.component';
import { Toaster, Type } from '../toaster/Toaster';
import { UserAttributeService } from '../service/finzy-flex/user/user-attribute.service';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'app-investorwallet',
    templateUrl: './investorwallet.component.html',
    styleUrls: ['./investorwallet.component.css'],
    providers: [ApiServiceService, PreferencesService]
})
export class InvestorwalletComponent implements OnInit {

    topupAmount: number;
    wallet: number;
    virtualAccountId: string;
    walletTransactions = false;
    data: any = [];
    fractionSize: any;
    dashLink: string;
    lender_application_status: string;
    shouldShowDataLoader: boolean;
    dataLoader: boolean = false;

    // check is finx user
    isFINXLender: boolean = false;
    
    displayedColumns: any = ['timestamp', 'transaction_type', 'amount'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    dataSource: any;
    private readonly preferencesService: PreferencesService;
    private readonly configService: ConfigService;
    private readonly router: Router;
    private readonly matDialog: MatDialog;
    private preferences: Preferences;
    private isSwiftON: boolean;
    private userAttributeService: UserAttributeService;
    private userId: string;

    constructor(private http: HttpClient, private ref: ApiServiceService, private storageService: StorageService,
                private lenderDashboardLinkProvider: LenderDashboardLinkProvider,
                preferencesService: PreferencesService, configService: ConfigService, private dialog: MatDialog, router: Router, matDialog: MatDialog, userAttributeService : UserAttributeService) {
        this.preferencesService = preferencesService;
        this.configService = configService;
        this.router = router;
        this.matDialog = matDialog;
        this.userAttributeService = userAttributeService;
        this.isFINXLender = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
    }

    async ngOnInit() {
        /**/
        this.userId = this.storageService.getItem(Keys.PROFILE_ID);
        this.shouldShowDataLoader = false;
        this.http.post<any>(this.ref.baseURL() + 'getLenderInfoDetails',
            {
                token: this.storageService.getItem(Keys.TOKEN),
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID)
            }).subscribe((result2) => {
                if (result2.status == 'success') {
                    this.lender_application_status = result2.lender_info.lender_application_status;
                    this.wallet = Math.round(result2.lender_info.wallet.amount * 100) / 100;
                    this.virtualAccountId = result2.lender_info.virtual_account_id;
                    if (result2.lender_info.wallet.transactions.length > 0) {
                        this.walletTransactions = false;
                        this.data = result2.lender_info.wallet.transactions;
                        this.dataSource = new MatTableDataSource(this.data);
                        this.dataSource.sort = this.sort;
                        this.dataSource.paginator = this.paginator;

                    } else {
                        this.walletTransactions = false;
                    }
                }
            });

        this.lenderDashboardLinkProvider.getDashboardLink().then(link => {
            this.dashLink = link;
        });

        this.preferences = await this.preferencesService.getUserPreferences(this.storageService.getItem(Keys.PROFILE_ID));
        this.shouldShowDataLoader = true;
        this.isSwiftON = this.isSwiftEnabled();
    }

    public areAutomaticInvestmentsFromWalletEnabled(): boolean {
        return this.preferences ? this.preferences.automaticInvestmentsFromWallet : false;
    }

    private isSwiftEnabled(): boolean {
        return this.preferences?.investmentAttrs.find(preference => preference.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE
            &&  preference.attributeValue === AttributeValue.SWIFT ) ? true: false;
    }

    openDiv() {
        this.walletTransactions = true;
    }

    public getSubstring(virtualAccountNumber: string, fromIndex: number, toIndex: number): string {
        return virtualAccountNumber.substring(fromIndex, toIndex);
    }

    public openVirtualAccountDescription(): void {
        this.dialog.open(VirtualAccountDescriptionPopUpComponent, {width: '700px'});
    }

    isFormValid(isValidInputValue: boolean): boolean {
       return (isValidInputValue && this.topupAmount > 0);
    }

    async onAddMoneyClick(topupAmount) {
        if(this.isFINXLender) {
            return;
        }

        if(this.isSwiftON) {
            this.showFinzySwiftPopup(topupAmount);
        }
        else {
            this.storageService.saveItem(Keys.PARENT_WALLET_PATH, '/investordashboard');
            await this.router.navigate(['payment/initiate'], { state: {topUpAmount: topupAmount, paymentProduct: PaymentProduct.UPDATE_LENDER_WALLET} });
        }
    }

    private showSwiftPopupWarning(data): Promise<boolean> {
        return this.matDialog.open(ConfirmationPopupWithSvgComponent, data).afterClosed().toPromise();
    }

    private async showFinzySwiftPopup(topupAmount) {
        const res = await this.showSwiftPopupWarning({
			data: {
				title: 'Switch Off Swift',
				subTitle: `Switch off <strong class="black">Swift</strong> to add funds`,
				message: `To add funds to your investment wallet, your existing auto investment option <strong class="black">(Swift)</strong> has to be switched off.`,
                positiveButtonText: 'Switch Off',
				negativeButtonText: 'Later',
				image: '../../../../../assets/gif/finzy-flex/switchOffForBolt.svg'
			},
			width: '50%',
			minWidth: '320px',
			panelClass: "confirm-dialog-with-svg-responsive"
		});
		if (res) {
            this.dataLoader = true;
			const allInvestmentPreferences = cloneDeep(this.preferences.investmentAttrs);
            const updatedPreferences = allInvestmentPreferences.filter(i => i.attributeCode != AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE && i.attributeCode != AttributeCode.INVESTMENT_FUND_ALLOCATION);
            var response: UserAttributeInterface = await this.userAttributeService.putUserAttribute({ investmentPreferences: updatedPreferences, automaticInvestmentsFromWallet: this.preferences.automaticInvestmentsFromWallet, isNCashModified: false, isSwiftModified: true }, this.userId);

            if (response.status === 0) {
                Toaster.toast('Preference updated successfully', Type.Success);
                this.storageService.saveItem(Keys.PARENT_WALLET_PATH, '/investordashboard');
                await this.router.navigate(['payment/initiate'], { state: {topUpAmount: topupAmount, paymentProduct: PaymentProduct.UPDATE_LENDER_WALLET} });
            } else {
                this.dataLoader = false;
                Toaster.toast('Failed to update preference. Please try again after sometime.', Type.Error);
            }
        }
    }
}
